import { MessageError } from "src/types/errors/errors";

export const missionsError: MessageError[] = [
    {
        key: 'Mission not found',
        value: 'Missão não está mais disponível.',
    },
    {
        key: 'Mission is not a check-in type',
        value: 'Missão não está mais disponível.',
    },
    {
        key: 'Location must have 2 coordinates',
        value: 'Erro ao capturar localização.',
    },
    {
        key: 'Location is too far from the mission location',
        value: 'Você deve estar no Shopping Center Norte, para realizar o check-in.',
    },
    {
        key: 'Wait for the next check-in date',
        value: 'Aguarde para realizar o próximo check-in.',
    },
    {
        key: 'Failed to credit points',
        value: 'Erro ao realizar missão. Tentar novamente mais tarde.',
    }
]